
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiEsperienzeDialog extends Serenity.EntityDialog<UtentiProdottiEsperienzeRow, any> {
        protected getFormKey() { return UtentiProdottiEsperienzeForm.formKey; }
        protected getIdProperty() { return UtentiProdottiEsperienzeRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiEsperienzeRow.localTextPrefix; }
        protected getService() { return UtentiProdottiEsperienzeService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiEsperienzeRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiEsperienzeRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiEsperienzeRow.updatePermission; }

        protected form = new UtentiProdottiEsperienzeForm(this.idPrefix);

        constructor() {
            super();
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }

        /**
         * This method is actually the one that calls getEntityTitle()
         * and updates the dialog title. We could do it here too...
        */
        protected updateTitle(): void {
            // super.updateTitle();

            // remove super.updateTitle() call above and uncomment
            // below line if you'd like to use this version
            //
            this.dialogTitle ="Missione";
        }

        validateBeforeSave() {
            var validato = super.validateBeforeSave();

            if (this.entity.IdProdottoEsperienzaPunteggioValoreNegativo == 0 && this.form.Valore.value < 0) {
                validato = false;
                Q.warning("Errore", "Il valore deve essere positivo");
            }

            return validato;
        }
    }
}